export const BASE_URL = import.meta.env.VITE_API_BASE_URL;
export const API_VERSION = "api/v1";
export const DEFAULT_LANGUAGE = "en";

// Socket configuration
// Base URL comes directly from VITE_SOCKET_BASE_URL so it can point to ws/wss host.
export const SOCKET_BASE_URL = import.meta.env.VITE_SOCKET_BASE_URL;
// Handshake path as provided by backend socket.io server.
// (Dashboards use this via SOCKET_PATH in the DashboardSocketProvider.)
export const SOCKET_PATH = "/backend/ws/socket.io";
